export default __webpack_public_path__ + "static/media/goOut.svg";